export interface ICommand { }

export class CreateCapexMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateCapexMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	AccountId: string
	IsDepreciation: boolean
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, accountId: string, isDepreciation: boolean, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.AccountId = accountId
		this.IsDepreciation = isDepreciation
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateCapexMetricCommandV1, TCh.Domain.Quest'
	}

}

export class CreateCostSubtotalMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateCostSubtotalMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	SubtotalId: string
	ValueBalanceType: any
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, subtotalId: string, valueBalanceType: any, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.SubtotalId = subtotalId
		this.ValueBalanceType = valueBalanceType
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateCostSubtotalMetricCommandV1, TCh.Domain.Quest'
	}

}

export class CreateExpenseMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateExpenseMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	ExpenseAccountId: string
	ValueBalanceType: any
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, expenseAccountId: string, valueBalanceType: any, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.ExpenseAccountId = expenseAccountId
		this.ValueBalanceType = valueBalanceType
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateExpenseMetricCommandV1, TCh.Domain.Quest'
	}

}

export class CreateMarginCogsMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateMarginCogsMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	RevenueId: string
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, revenueId: string, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.RevenueId = revenueId
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateMarginCogsMetricCommandV1, TCh.Domain.Quest'
	}

}

export class CreateOpexMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateOpexMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	CostIds: any
	ValueBalanceType: any
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, costIds: any, valueBalanceType: any, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.CostIds = costIds
		this.ValueBalanceType = valueBalanceType
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateOpexMetricCommandV1, TCh.Domain.Quest'
	}

}

export class CreateResourceCostMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateResourceCostMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	ResourceId: string
	ValueBalanceType: any
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, resourceId: string, valueBalanceType: any, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.ResourceId = resourceId
		this.ValueBalanceType = valueBalanceType
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateResourceCostMetricCommandV1, TCh.Domain.Quest'
	}

}

export class CreateResourceMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateResourceMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	ResourceId: string
	ValueBalanceType: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, resourceId: string, valueBalanceType: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.ResourceId = resourceId
		this.ValueBalanceType = valueBalanceType
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateResourceMetricCommandV1, TCh.Domain.Quest'
	}

}

export class CreateRevenueMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateRevenueMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	RevenueId: string
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, revenueId: string, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.RevenueId = revenueId
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateRevenueMetricCommandV1, TCh.Domain.Quest'
	}

}

export class CreateTotalCostMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.CreateTotalCostMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	RevenueId: string
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, revenueId: string, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.RevenueId = revenueId
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.CreateTotalCostMetricCommandV1, TCh.Domain.Quest'
	}

}

export class DeleteMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.DeleteMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string

	constructor (workspaceId: number, strategyId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.DeleteMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateCapexMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateCapexMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	AccountId: string
	IsDepreciation: boolean
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, accountId: string, isDepreciation: boolean, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.AccountId = accountId
		this.IsDepreciation = isDepreciation
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateCapexMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateCostSubtotalMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateCostSubtotalMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	SubtotalId: string
	ValueBalanceType: any
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, subtotalId: string, valueBalanceType: any, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.SubtotalId = subtotalId
		this.ValueBalanceType = valueBalanceType
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateCostSubtotalMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateExpenseMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateExpenseMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	ExpenseAccountId: string
	ValueBalanceType: any
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, expenseAccountId: string, valueBalanceType: any, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.ExpenseAccountId = expenseAccountId
		this.ValueBalanceType = valueBalanceType
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateExpenseMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateMarginCogsMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateMarginCogsMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	RevenueId: string
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, revenueId: string, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.RevenueId = revenueId
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateMarginCogsMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateOpexMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateOpexMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	CostIds: any
	ValueBalanceType: any
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, costIds: any, valueBalanceType: any, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.CostIds = costIds
		this.ValueBalanceType = valueBalanceType
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateOpexMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateResourceCostMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateResourceCostMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	ResourceId: string
	ValueBalanceType: any
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, resourceId: string, valueBalanceType: any, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.ResourceId = resourceId
		this.ValueBalanceType = valueBalanceType
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateResourceCostMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateResourceMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateResourceMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	ResourceId: string
	ValueBalanceType: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, resourceId: string, valueBalanceType: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.ResourceId = resourceId
		this.ValueBalanceType = valueBalanceType
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateResourceMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateRevenueMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateRevenueMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	RevenueId: string
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	IsScheduleDependent: boolean
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, revenueId: string, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, isScheduleDependent: boolean, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.RevenueId = revenueId
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.IsScheduleDependent = isScheduleDependent
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateRevenueMetricCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateTotalCostMetricCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.Metrics.Commands.UpdateTotalCostMetricCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	Id: string
	Name: string
	Description: string
	Denomination: any
	WindowStartOffsetInMonths: number | null
	WindowLengthInMonths: number | null
	DefaultProjectStartDate: any | null
	StartDateBoundary: any | null
	EndDateBoundary: any | null
	ValueCommitmentType: any
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, strategyId: string, id: string, name: string, description: string, denomination: any, windowStartOffsetInMonths: number | null, windowLengthInMonths: number | null, defaultProjectStartDate: any | null, startDateBoundary: any | null, endDateBoundary: any | null, valueCommitmentType: any, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.Id = id
		this.Name = name
		this.Description = description
		this.Denomination = denomination
		this.WindowStartOffsetInMonths = windowStartOffsetInMonths
		this.WindowLengthInMonths = windowLengthInMonths
		this.DefaultProjectStartDate = defaultProjectStartDate
		this.StartDateBoundary = startDateBoundary
		this.EndDateBoundary = endDateBoundary
		this.ValueCommitmentType = valueCommitmentType
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.Metrics.Commands.UpdateTotalCostMetricCommandV1, TCh.Domain.Quest'
	}

}

